import isBillesByName from 'utils/isBillesByName'
import isBilles from 'utils/isBilles'
import nameSort from 'utils/nameSort'

export default function initNodePanel({ props, state }) {
  const {
    path,
    edit,
    name = '',
    id,
    parent,
    groups,
    parentGroups = [],
    fromDate,
    toDate
  } = props

  const { group } = state.get('app.user')
  const allGroups = state.get('app.client.groups')

  let reduceGroups = []
  let currentGroups = []

  // new root node
  if (!edit && !id) {
    reduceGroups = allGroups
    currentGroups = allGroups
  }

  // new sub node
  if (!edit && id) {
    reduceGroups = groups
    currentGroups = groups
  }

  // edit subnode
  if (edit && parentGroups) {
    reduceGroups = parentGroups
    currentGroups = groups
  }

  // edit root node
  if (edit && !parent) {
    reduceGroups = allGroups
    currentGroups = groups
  }

  let index = 0
  const tags = currentGroups.reduce((acc, nodeGroup) => {
    let pinned = false
    if (nodeGroup === group.name || isBillesByName(nodeGroup)) {
      pinned = true
    }
    acc[`${index}`] = {
      label: nodeGroup,
      selected: true,
      pinned,
      hidden: isBillesByName(nodeGroup) && !isBilles(group)
    }
    index++

    return acc
  }, {})

  const allTags = reduceGroups.reduce((acc, group) => {
    if (currentGroups.indexOf(group) === -1) {
      acc[`${index}`] = {
        label: group,
        selected: false
      }
      index++
    }

    return acc
  }, tags)

  const sortedTags = Object.keys(allTags)
    .sort((g1, g2) => {
      return nameSort(allTags[g1].label, allTags[g2].label)
    })
    .map(index => {
      return allTags[index]
    })

  state.set('node.panel', {
    name: {
      value: edit ? name : '',
      isRequired: true,
      validationRules: ['preventBlanksBefore']
    },
    fromDate,
    toDate,
    id,
    edit,
    tags: sortedTags,
    show: true,
    parent,
    path
  })
}



// WEBPACK FOOTER //
// ./src/modules/Node/actions/initNodePanel.js